import {
    defaultTheme,
    DrSmileTheme,
    SmajlaTheme,
    SYTtheme,
    SYTthemeDark,
} from "@smile2impress/themes";
import { darkTheme } from "themes/dark-theme";

import { CustomTheme, Theme } from "constants/enum";

export const getIDSTheme = (themeType?: Theme | CustomTheme) => {
    switch (themeType) {
        case Theme.SYT:
            return SYTtheme;
        case Theme.SYTDark:
            return SYTthemeDark;
        case Theme.DARK:
            return darkTheme;
        case CustomTheme.DRSMILE:
            return DrSmileTheme;
        case CustomTheme.SMAJLA:
            return SmajlaTheme;
        default:
            return defaultTheme;
    }
};
